export default __webpack_public_path__ + "static/media/nick_carr.0f3cfd56.jpg";